export enum EXPENSE_TYPES {
	TUITION = 'tuition',
	COURSE_RELATED = 'courseRelated',
	NON_COURSE_RELATED = 'nonCourseRelated'
}
